var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39667 9.96409C8.305 9.95492 8.195 9.95492 8.09417 9.96409C5.9125 9.89075 4.18 8.10325 4.18 5.90325C4.18 3.65742 5.995 1.83325 8.25 1.83325C10.4958 1.83325 12.32 3.65742 12.32 5.90325C12.3108 8.10325 10.5783 9.89075 8.39667 9.96409Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0425 3.66675C16.8208 3.66675 18.2508 5.10591 18.2508 6.87508C18.2508 8.60758 16.8758 10.0192 15.1617 10.0834C15.0883 10.0742 15.0058 10.0742 14.9233 10.0834",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81333 13.3467C1.595 14.8317 1.595 17.2517 3.81333 18.7276C6.33417 20.4142 10.4683 20.4142 12.9892 18.7276C15.2075 17.2426 15.2075 14.8226 12.9892 13.3467C10.4775 11.6692 6.34333 11.6692 3.81333 13.3467Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8117 18.3333C17.4717 18.1958 18.095 17.9299 18.6083 17.5358C20.0383 16.4633 20.0383 14.6941 18.6083 13.6216C18.1042 13.2366 17.49 12.9799 16.8392 12.8333",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.30253f10337735c6427fb39521a32a04.svg";
export { ForwardRef as ReactComponent };